import React, { Component } from "react";
import ReactDOM from "react-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default class SearchForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "",
      bill_flag: "",
      client_id: "",
      staff_id: "",
      created_at: null,
      hiragana_name: "",
      fullname: "",
      nickname: "",
      tel: "",
      email: "",
      anti_check: "",
      reach_from: "",
      pref: "",
      page: 1,
      prefs: [],
      accessed_at_from:null,
      accessed_at_to:null,
    };
    this.handleChangeDateCreated = this.handleChangeDateCreated.bind(this);
    this.handleChangeDateAccessed = this.handleChangeDateAccessed.bind(this)
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleSearchData = this.handleSearchData.bind(this);
    this.resetInputField = this.resetInputField.bind(this);
  }

  /**
   * Init data
   */
  componentWillMount() {
    axios.get("/api/prefs").then((response) => {
      this.setState({
        prefs: response.data,
      });
    });
  }

  /**
   * Call search data by text
   */
  handleSearchData() {
    const searchForm = {
      status: this.state.status,
      bill_flag: this.state.bill_flag,
      client_id: this.state.client_id,
      staff_id: this.state.staff_id,
      created_at_from: this.state.created_at_from
        ? this.state.created_at_from.format("YYYY-MM-DD")
        : "",
      created_at_to: this.state.created_at_to
      ? this.state.created_at_to.format("YYYY-MM-DD")
      : "",
      hiragana_name: this.state.hiragana_name,
      fullname: this.state.fullname,
      nickname: this.state.nickname,
      tel: this.state.tel,
      email: this.state.email,
      anti_check: this.state.anti_check,
      reach_from: this.state.reach_from,
      pref: this.state.pref,
      accessed_at_from: this.state.accessed_at_from
        ? this.state.accessed_at_from.format("YYYY-MM-DD")
        : "",
      accessed_at_to: this.state.accessed_at_to
      ? this.state.accessed_at_to.format("YYYY-MM-DD")
      : "",
    };
    if (typeof this.props.onSearch === "function") {
      this.props.onSearch(searchForm);
    }
  }

  /**
   * Process change date create at
   */
  handleChangeDateCreated(date, dateType) {
    if (dateType == "from") {
      this.setState({
        created_at_from: date,
      });
    } else {
      this.setState({
        created_at_to: date,
      });
    }

  }
  handleChangeDateAccessed(date, dateType) {
    if (dateType == "from") {
      this.setState({
        accessed_at_from: date,
      });
    } else {
      this.setState({
        accessed_at_to: date,
      });
    }
  }

  /**
   * Process field change
   */
  handleFieldChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  /**
   * Clear data input field
   */
  resetInputField() {
    this.setState({
      status: "",
      bill_flag: "",
      client_id: "",
      staff_id: "",
      created_at_from:null,
      created_at_to:null,
      hiragana_name: "",
      fullname: "",
      nickname: "",
      tel: "",
      email: "",
      anti_check: "",
      reach_from: "",
      pref: "",
      accessed_at_from:null,
      accessed_at_to:null,
    });
  }

  render() {
    return (
      <div className="collapse multi-collapse" id="search_client">
        <div className="card mt-3">
          <div className="card-header">登録者を検索する条件</div>
          <div className="card-body">
            <div className="row">
              <div className="col-sm-3">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    ステータス
                  </label>
                  <select
                    className="form-control"
                    name="status"
                    value={this.state.status}
                    onChange={this.handleFieldChange}
                  >
                    <option value="all">すべて</option>
                    <option value="0">未承認</option>
                    <option value="1">承認</option>
                    <option value="8">停止</option>
                    <option value="9">否認</option>
                    <option value="承認と否認">承認と否認</option>
                  </select>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    種別
                  </label>
                  <select
                    className="form-control"
                    name="bill_flag"
                    value={this.state.bill_flag}
                    onChange={this.handleFieldChange}
                  >
                    <option value="all">すべて</option>
                    <option value="1">法人</option>
                    <option value="2">個人</option>
                  </select>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    依頼者ID
                  </label>
                  <input
                    type="text"
                    name="client_id"
                    onChange={this.handleFieldChange}
                    value={this.state.client_id}
                    className="form-control"
                    placeholder="依頼者ID"
                  />
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    ワーカーID
                  </label>
                  <input
                    type="text"
                    name="staff_id"
                    onChange={this.handleFieldChange}
                    value={this.state.staff_id}
                    className="form-control"
                    placeholder="ワーカーID"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-3">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    登録日(開始)
                  </label>
                  <div className="input-group">
                    <DatePicker
                      locale="ja-JP"
                      className="form-control form_datepicker"
                      dateFormat="YYYY/MM/DD"
                      selected={this.state.created_at_from}
                      onChange={(e) => {
                        this.handleChangeDateCreated(e, "from");
                      }}
                      placeholderText="登録日(開始)"
                      disabledKeyboardNavigation
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        id="form-calendar"
                      >
                        <i className="material-icons">calendar_today</i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    登録日(終了)
                  </label>
                  <div className="input-group">
                    <DatePicker
                      locale="ja-JP"
                      className="form-control form_datepicker"
                      dateFormat="YYYY/MM/DD"
                      selected={this.state.created_at_to}
                      onChange={(e) => {
                        this.handleChangeDateCreated(e, "to");
                      }}
                      placeholderText="登録日(終了)"
                      disabledKeyboardNavigation
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        id="form-calendar"
                      >
                        <i className="material-icons">calendar_today</i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    お名前(カナ)
                  </label>
                  <input
                    type="text"
                    name="hiragana_name"
                    onChange={this.handleFieldChange}
                    value={this.state.hiragana_name}
                    className="form-control"
                    placeholder="お名前（カナ）"
                  />
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    お名前
                  </label>
                  <input
                    type="text"
                    name="fullname"
                    onChange={this.handleFieldChange}
                    value={this.state.fullname}
                    className="form-control"
                    placeholder="お名前"
                  />
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    ニックネーム
                  </label>
                  <input
                    type="text"
                    onChange={this.handleFieldChange}
                    value={this.state.nickname}
                    name="nickname"
                    className="form-control"
                    placeholder="ニックネーム"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-3">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    電話番号
                  </label>
                  <input
                    type="text"
                    onChange={this.handleFieldChange}
                    value={this.state.tel}
                    className="form-control"
                    name="tel"
                    placeholder="電話番号(ハイフンあり)"
                  />
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    メールアドレス
                  </label>
                  <input
                    type="text"
                    onChange={this.handleFieldChange}
                    value={this.state.email}
                    className="form-control"
                    name="email"
                    placeholder="メール"
                  />
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    反社チェック
                  </label>
                  <select
                    className="form-control"
                    name="anti_check"
                    value={this.state.anti_check}
                    onChange={this.handleFieldChange}
                  >
                    <option value="all">すべて</option>
                    <option value="mitaiou">未対応</option>
                    <option value="9">問題なし</option>
                    <option value="1">問題あり</option>
                  </select>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    経由
                  </label>
                  <select
                    className="form-control"
                    name="reach_from"
                    value={this.state.reach_from}
                    onChange={this.handleFieldChange}
                  >
                    <option value="">すべて</option>
                    <option value="1">Google</option>
                    <option value="2">Yahoo</option>
                    <option value="12">インディード</option>
                    <option value="13">ワーキン</option>
                    <option value="15">engage</option>
                    <option value="3">その他webサイト</option>
                    <option value="4">Twitter</option>
                    <option value="5">Instagram</option>
                    <option value="6">Facebook</option>
                    <option value="7">テレビ</option>
                    <option value="8">新聞記事</option>
                    <option value="9">雑誌</option>
                    <option value="14">チラシ</option>
                    <option value="10">紹介</option>
                    <option value="16">農業Week</option>
                    <option value="11">エントリースタッフ</option>
                    <option value="99">その他</option>
                  </select>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    都道府県
                  </label>
                  <select
                    className="form-control"
                    name="pref"
                    value={this.state.pref}
                    onChange={this.handleFieldChange}
                  >
                    <option value="">すべて</option>
                    {this.state.prefs.map((ref) => {
                      return (
                        <option key={ref.id} value={ref.id}>
                          {ref.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    最終ログイン日(開始)
                  </label>
                  <div className="input-group">
                    <DatePicker
                      locale="ja-JP"
                      className="form-control form_datepicker"
                      dateFormat="YYYY/MM/DD"
                      selected={this.state.accessed_at_from}
                      onChange={(e) => {
                        this.handleChangeDateAccessed(e, "from");
                      }}
                      placeholderText="最終ログイン日(開始)"
                      disabledKeyboardNavigation
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        id="form-calendar"
                      >
                        <i className="material-icons">calendar_today</i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    最終ログイン日(終了)
                  </label>
                  <div className="input-group">
                    <DatePicker
                      locale="ja-JP"
                      className="form-control form_datepicker"
                      dateFormat="YYYY/MM/DD"
                      selected={this.state.accessed_at_to}
                      onChange={(e) => {
                        this.handleChangeDateAccessed(e, "to");
                      }}
                      placeholderText="最終ログイン日(終了)"
                      disabledKeyboardNavigation
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        id="form-calendar"
                      >
                        <i className="material-icons">calendar_today</i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer text-center">
            <button
              type="reset"
              onClick={this.resetInputField}
              className="btn btn-light"
            >
              リセット
            </button>
            <button
              onClick={this.handleSearchData}
              type="submit"
              className="btn btn-secondary"
            >
              検索する
            </button>
          </div>
        </div>
      </div>
    );
  }
}
